export default __webpack_public_path__ + "static/media/pyberlin.48e5dfb8.png";